import React from 'react';
import { Box, Icon, Typography } from '@drone-js/core';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, InCitySearchOverlayProps as Props } from 'component/common/InCitySearchKeyword/InCitySearchKeyword.selectors';
import { StringFormatter } from '@agoda/react-handyman';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesInCitySearchResultClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesInCitySearchResultClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';

const InCitySearchKeywordComponent: React.FC<Props> = (props: Props) => {
    const { geo, cms, inputText, onKeywordResultClick } = props;
    const isShowKeywordSearch = inputText.length > 0;

    const cityName = geo?.cityName || '';
    const keywordText = (
        <Typography display="inline-block" variant="body-s-strong">
            {inputText}
        </Typography>
    );

    const keywordSearchClickHandler = () => {
        trackElementEvent<ActivitiesInCitySearchResultClickEventActivitiesFieldsV1>(ActivitiesInCitySearchResultClickEventActivitiesManifestV1.ids, {
            search_phrase: inputText,
        });
        geo && onKeywordResultClick(inputText, geo);
    };

    return (
        <Box data-testid="in-city-content-container" maxWidth="744px" mx="auto" px={props.isDesktop ? '4' : '12'} py="0" mb="0" width="100%">
            {isShowKeywordSearch && (
                <Box
                    as="button"
                    interactive="product.primary"
                    width="100%"
                    p="12"
                    display="flex"
                    onClick={keywordSearchClickHandler}
                    data-testid="activities-in-city-keyword-item"
                    borderRadius="8"
                    my="8"
                    mx="0"
                >
                    <Icon id="fill.symbol.search" size="24" color="product.primary" me="12" />
                    <Typography variant="body-s" mt="4">
                        {StringFormatter.formatToJsx(cms[316646], keywordText, cityName)}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

InCitySearchKeywordComponent.displayName = 'InCitySearchKeywordComponent';

const InCitySearchKeyword = connect(mapStateToProps, mapDispatchToProps)(InCitySearchKeywordComponent);

export default InCitySearchKeyword;
